import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { PersonalizationSettings } from '@/api/apis/communication/personalization';
import { personalizationQueryKeys } from '@/queries/communication/personalization/personalization.query.keys';
import { api } from '@/api';

export const personalizationQueries = {
  all: () =>
    queryOptions({
      queryKey: personalizationQueryKeys.getList(),
      queryFn: () => api.personalization.getPersonalizationSettings(),
      retry: 0,
    }),
};

const usePersonalizationQuery = (): UseQueryResult<PersonalizationSettings, Error> => {
  return useQuery(personalizationQueries.all());
};

export { usePersonalizationQuery };
